import React from 'react';
import PropTypes from 'prop-types';
import styles from './pagination.module.css';

Pagination.propTypes = {
  fullCount: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default function Pagination({
  fullCount,
  perPage,
  currentPage,
  onPageChange,
  disabled = false,
}) {
  const totalPages = Math.ceil(fullCount / perPage);
  if (totalPages <= 1) return null;
  const downDisabled = disabled || currentPage === 1;
  const upDisabled = disabled || currentPage === totalPages || totalPages === 0;

  const pageUp = () => {
    if (!upDisabled) onPageChange(currentPage + 1);
  };

  const pageDown = () => {
    if (!downDisabled) onPageChange(currentPage - 1);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <button className={styles.prev} disabled={downDisabled} onClick={pageDown}>
        Previous Page
      </button>
      <button className={styles.next} disabled={upDisabled} onClick={pageUp}>
        Next Page
      </button>
      {!!fullCount && (
        <span>
          Page {currentPage} of {totalPages || 0}
        </span>
      )}
    </div>
  );
}
